// // components/SucursalesMercadoLibre/index.js
// import React, { useState, useEffect } from 'react';
// import axios from 'axios';
// import {
//   Container,
//   Box,
//   Typography,
//   Alert,
//   Snackbar,
//   CircularProgress,
//   Paper,
// } from '@mui/material';
// import { Add as AddPosIcon } from '@mui/icons-material';
// import CajaForm from './CajaForm';
// import SucursalList from './SucursalList';
// import Navbar from '../../Navbar';
// import { sucursalLocalApi } from './sucursalLocalApi';

// const SucursalesMercadoLibre = () => {
//   const [sucursales, setSucursales] = useState([]);
//   const [cajas, setCajas] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [showCajaForm, setShowCajaForm] = useState(false);
//   const [selectedSucursal, setSelectedSucursal] = useState(null);
//   const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });

//   const API_BASE_URL = 'https://mphipergas.netizar.com';

//   useEffect(() => {
//     cargarSucursales();
//     cargarCajas();
//   }, []);

//   const showSnackbar = (message, severity = 'success') => {
//     setSnackbar({ open: true, message, severity });
//   };

//   const cargarSucursales = async () => {
//     try {
//       const response = await axios.get(`${API_BASE_URL}/api/qr/mp/stores`);
//       setSucursales(response.data.results || []);
//     } catch (err) {
//       console.error('Error al cargar sucursales:', err);
//     }
//   };

//   const cargarCajas = async () => {
//     setLoading(true);
//     try {
//       const response = await axios.get(`${API_BASE_URL}/api/qr/mp/pos`);
//       setCajas(response.data.results || []);
//     } catch (err) {
//       showSnackbar('Error al cargar cajas: ' + (err.response?.data?.message || err.message), 'error');
//     } finally {
//       setLoading(false);
//     }
//   };

// const crearCaja = async (cajaData) => {
//   setLoading(true);
//   try {
//     // 1. Guardar en Mercado Pago
//     const response = await axios.post(`${API_BASE_URL}/api/qr/mp/pos`, cajaData);
//     console.log("cajadata",cajaData);
    
//     // 2. Si fue exitoso, guardar en BD local con todos los campos
//     if (response.data && response.data.id) {
//       await sucursalLocalApi.guardarCajaLocal({
//         id: response.data.id,                    // mp_pos_id
//         name: response.data.name,                // nombre
//         external_id: response.data.external_id,  // external_id
//         sucursal_id: cajaData.store_id, 
//         usuario: localStorage.getItem("user")         // sucursal_id (viene del formulario)
//         // Los campos activo, sincronizado, usuario se setean en el API
//       });
//     }
    
//     showSnackbar(`Caja "${cajaData.name}" creada exitosamente`);
//     await cargarCajas();
//     setShowCajaForm(false);
//     setSelectedSucursal(null);
//     return response.data;
//   } catch (err) {
//     showSnackbar('Error al crear caja: ' + (err.response?.data?.message || err.message), 'error');
//     throw err;
//   } finally {
//     setLoading(false);
//   }
// };

//   const eliminarCaja = async (posId) => {
//     setLoading(true);
//     try {
//       await axios.delete(`${API_BASE_URL}/api/qr/mp/pos/${posId}`);
//       await sucursalLocalApi.eliminarCajaLocal(posId);
//       showSnackbar('Caja eliminada exitosamente');
//       await cargarCajas();
//     } catch (err) {
//       showSnackbar('Error al eliminar caja: ' + (err.response?.data?.message || err.message), 'error');
//     } finally {
//       setLoading(false);
//     }
//   };

// const actualizarCaja = async (posId, updateDataMP, updateDataLocal) => {
//   setLoading(true);
//   try {
//     // console.log("📤 updateDataMP recibido:", updateDataMP);
//     // console.log("📤 updateDataLocal recibido:", updateDataLocal);
    
//     // 1. Actualizar en Mercado Pago
//     const response = await axios.put(`${API_BASE_URL}/api/qr/mp/pos/${posId}`, updateDataMP);
    
//     // 2. Actualizar en BD local
//     if (response.data && updateDataLocal) {
//       console.log("Actualizando BD local con:", updateDataLocal);
//       await sucursalLocalApi.actualizarCajaLocal(posId, updateDataLocal);
//     }
    
//     showSnackbar('Caja actualizada exitosamente');
//     await cargarCajas();
//     return response.data;
//   } catch (err) {
//     showSnackbar('Error al actualizar caja: ' + (err.response?.data?.message || err.message), 'error');
//     throw err;
//   } finally {
//     setLoading(false);
//   }
// };

//   const formatearExternalId = (nombre) => {
//     return nombre
//       .toUpperCase()
//       .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
//       .replace(/[^A-Z0-9]/g, '_')
//       .slice(0, 40);
//   };

//   const recargarTodo = async () => {
//     await cargarSucursales();
//     await cargarCajas();
//   };

//   return (
//     <Container maxWidth="xl" sx={{ py: 2 }}>
//       <Navbar/>

//       <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
//         <Typography variant="h5" fontWeight="600">
//           Gestión de Cajas Mercado Pago
//         </Typography>
//         {!showCajaForm && (
//           <button 
//             onClick={() => setShowCajaForm(true)}
//             style={{
//               backgroundColor: '#009ee3',
//               color: 'white',
//               border: 'none',
//               padding: '8px 16px',
//               borderRadius: '8px',
//               cursor: 'pointer',
//               display: 'flex',
//               alignItems: 'center',
//               gap: '8px'
//             }}
//           >
//             <AddPosIcon /> Nueva Caja
//           </button>
//         )}
//       </Box>

//       {loading && (
//         <Box sx={{ display: 'flex', justifyContent: 'center', my: 4 }}>
//           <CircularProgress sx={{ color: '#009ee3' }} />
//         </Box>
//       )}

//       <Paper elevation={1} sx={{ p: 3, borderRadius: 2 }}>
//         {showCajaForm ? (
//           <CajaForm
//             onCreate={crearCaja}
//             onCancel={() => {
//               setShowCajaForm(false);
//               setSelectedSucursal(null);
//             }}
//             sucursales={sucursales}
//             selectedSucursal={selectedSucursal}
//             formatearExternalId={formatearExternalId}
//           />
//         ) : (
//           <SucursalList
//             sucursales={sucursales}
//             cajas={cajas}
//             onEliminarCaja={eliminarCaja}
//             onActualizarCaja={actualizarCaja}
//             onSeleccionarSucursal={(sucursal) => {
//               setSelectedSucursal(sucursal);
//               setShowCajaForm(true);
//             }}
//             onRecargar={recargarTodo}
//             // Props de sucursales (no se usan pero se pasan por si acaso)
//             onEliminarSucursal={() => {}}
//             onActualizarSucursal={() => {}}
//           />
//         )}
//       </Paper>

//       <Snackbar
//         open={snackbar.open}
//         autoHideDuration={6000}
//         onClose={() => setSnackbar({ ...snackbar, open: false })}
//         anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
//       >
//         <Alert 
//           onClose={() => setSnackbar({ ...snackbar, open: false })} 
//           severity={snackbar.severity}
//           sx={{ width: '100%' }}
//         >
//           {snackbar.message}
//         </Alert>
//       </Snackbar>
//     </Container>
//   );
// };

// export default SucursalesMercadoLibre;
import React from 'react';
import { Container, Box } from '@mui/material';
import Navbar from '../../Navbar';
import GasTabs from './GasTabs';

const SucursalesMercadoLibre = () => {
  return (
    <Container maxWidth="xl" sx={{ py: 2 }}>
      <Navbar />
      <Box sx={{ mt: 2 }}>
        <GasTabs />
      </Box>
    </Container>
  );
};

export default SucursalesMercadoLibre;